import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { Multiselect } from "multiselect-react-dropdown";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import { Table } from "react-bootstrap";
import { useHistory,Link } from "react-router-dom";
function RiderPricing() {
  const history = useHistory();
  const objectArray_3 = [{ vehicle: "Bike", vehicleType: "Two Wheeler" }];
  const objectArray_4 = [{ vehicle: "3 Wheeler", vehicleType: "3 Wheeler" }];
  const objectArray_2 = [{ vehicle: "Auto", vehicleType: "Three Wheeler" }];

  const objectArray = [
    { vehicle: "SUV/MUV", vehicleType: "Four Wheeler" },
    { vehicle: "Sedan", vehicleType: "Four Wheeler" },
    { vehicle: "Hatch Back", vehicleType: "Four Wheeler" },
  ];
  const objectArray_1 = [
    { vehicle: "Tata Ace", vehicleType: "Four Wheeler" },
    { vehicle: "PickUp 8ft", vehicleType: "Four Wheeler" },
    { vehicle: "Tata 407", vehicleType: "Four Wheeler" },
  ];

  const objectArray2_1 = [
    // category[0].category == "On Movers" ? "" : { category: "Bike", },

    { category11: "Two Wheeler" },
    { category11: "3 Wheeler" },
    { category11: "truck" },
  ];
  const objectArray2_2 = [
    { category11: "car" },
    { category11: "auto" },
    { category11: "Two Wheeler" },
  ];
  const objectArray2_5 = [{ category11: "car" }];
  const objectArray2_3 = [{ category11: "two-wheeler" }];
  const objectArray2_4 = [{ category11: "Two Wheeler" }];

  const [Base_KM, setBaseKM] = useState(0);
  const [vehicleDes, setVehicleDes] = useState("");
  const [riderComm, setRiderComm] = useState(0);
  const [Base_Fare, setBaseFare] = useState(0);
  const [transFee, setTransFee] = useState(0);
  const [uptoBaseFare, setUptoBaseFare] = useState(0);
  const [uptoBaseKm, setUptoBaseKm] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [searchDistance, setSearchDistance] = useState(0);
  const [cityName, setCityName] = useState("");
  const [cityNameArray, setCityNameArray] = useState([]);
  const [Per_KM, setPerKM] = useState(0);
  const [penalty, setPenalty] = useState(0);
  const [tax, setTax] = useState(0);
  const [hike, setHike] = useState(0);
  const [peakMorning, setPeakMorning] = useState(0);
  const [peakEvening, setPeakEvening] = useState(0);
  // const [selectedValues, setselectedValues] = useState([
  //   { vehicleType: "", vehicle: "" },
  // ]);
  const [category, setCategory] = useState([{ category: "" }]);
  const [category1, setCategory1] = useState([{ category11: "" }]);
  const [category11, setCategory11] = useState([{ vehicle: "" }]);
  const [pricing, setpricing] = useState([]);
  const [vehicle, setpushvehicle] = useState([]);
  const [catList, setCatList] = useState([]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (category[0].category == "") {
      swal("Oops", "category not added", "error", {
        button: "Try Again!",
        timer: 1000,
      });
    } else if (category1[0].category11 == "") {
      swal("Oops", "Vehicle type not added", "error", {
        button: "Try Again!",
        timer: 1000,
      });
    } else if (category11[0].vehicle == "") {
      swal("Oops", "Vehicle  not added", "error", {
        button: "Try Again!",
        timer: 1000,
      });
    } else {
      const artical = {
        Category: `${category[0].category}`,
        Vehicle: vehicle,
        City: cityNameArray,
        Tax: tax,
        Penalty: penalty,
        Hike: hike,
        MorningHike: peakMorning,
        EveningHike: peakEvening,
      };
      axios
        .post(Baseurl.baseurl + "/go-pricing/add-pricing", artical)
        .then(
          (response) =>
            response.data.status
              ? swal("Pricing Added", response.data.message, "success", {
                  button: "Done",
                  timer: 1000,
                })
              : swal("Oops", response.data.message, "error", {
                  button: "Try Again!",
                  timer: 1000,
                }),
          setpushvehicle([]),
          history.push("/pricing-list")
        )
        .catch((err) => {
          if (err.toString() === "Error: Network Error") {
            history.push("/offline");
          } else {
            history.push("/400");
          }
        });
    }
  };
  // const selection = (selectedValues) => {
  //   setselectedValues(selectedValues);
  // };

  const selection1 = (selectedValues) => {
    setCategory(selectedValues);
  };
  const selection11 = (selectedValues) => {
    setCategory1(selectedValues);
  };
  const selection111 = (selectedValues) => {
    setCategory11(selectedValues);
  };
  function getCategory() {
    let cat = [];
    axios
      .get(Baseurl.baseurl + `/go-ui/get-category`)
      .then((res) => {
        res.data.categories.map((val) => {
          cat.push({ category: val.Category });
        });
        cat.push({ category: "others" });
        setCatList(cat);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  useEffect(() => {
    getCategory();
    axios
      .get(Baseurl.baseurl + "/go-pricing/get-all-pricing")
      .then((response) => {
        setpricing(response.data.pricing);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }, []);

  // const deleteHandle = (p) => {
  //   axios
  //     .delete(Baseurl.baseurl + `/go-pricing/delete-pricing-full/${p}`)
  //     .then((response) =>
  //       axios
  //         .get(Baseurl.baseurl + "/go-pricing/get-all-pricing")
  //         .then((response) => {
  //           setpricing(response.data.pricing);
  //         })
  //     );
  // };
  const Add = () => {
    var vehicle = category11[0].vehicle;
    var vehicleType = category1[0].category11;
    const vehicle1 = {
      VehicleType: vehicleType,
      Name: vehicle,
      Base_KM: Base_KM,
      Base_Fare: Base_Fare,
      Per_KM: Per_KM,
      UptoBaseKM: uptoBaseKm,
      UptoPerKM: uptoBaseFare,
      VehicleDescription: vehicleDes,
      VehicleTransactionFee: transFee,
      VehicleDiscount: discount,
      RiderCommission: riderComm,
      SearchDistance: searchDistance,
    };
    setpushvehicle(
      (oldArray) => oldArray.concat(vehicle1),
      () => {}
    );
    swal("Added", "Added successfully", "success", {
      showCancelButton: true,
      timer: 1000,
    });
    setBaseKM(0);
    setBaseFare(0);
    setPerKM(0);
    setUptoBaseKm(0);
    setUptoBaseFare(0);
    setVehicleDes("");
    setTransFee(0);
    setDiscount(0);
    setVehicleDes("");
  };
  // const handleSelect = (key) => {
  //   if (key == 1)
  //     setselectedValues({ vehicle: "Bike", vehicleType: "two wheeler" });
  //   else if (key == 2)
  //     setselectedValues({ vehicle: "TataAC", vehicleType: "four wheeler" });
  //   else if (key == 3)
  //     setselectedValues({
  //       vehicle: "Three Wheeler",
  //       vehicleType: "Three Wheeler",
  //     });
  //   else if (key == 4)
  //     setselectedValues({ vehicle: "Pickup 8ft", vehicleType: "four wheeler" });
  //   else if (key == 5)
  //     setselectedValues({ vehicle: "Tata 407", vehicleType: "four wheeler" });
  // };
  return (
    <div className="col-16">
      <div
        className="card text-sm"
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <div className="card-header">
          <h4 className="card-title text-white">Vehicle Pricing</h4>
        </div>
        <div className="card-body">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="form-group row">
                  <div className="col-sm-4 mb-2" id="multiselect">
                    <label>Category</label>
                    <Multiselect
                      options={catList}
                      singleSelect
                      displayValue="category"
                      onSelect={selection1}
                    />
                  </div>
                  <div className="col-sm-4 mb-5" id="multiselect">
                    <label>Vehicle Type</label>
                    <Multiselect
                      singleSelect
                      options={
                        category[0].category === "Go_Movers"
                          ? objectArray2_1
                          : category[0].category === "Go_Taxi"
                          ? objectArray2_2
                          : category[0].category === "Go_Food"
                          ? objectArray2_4
                          : category[0].category === "Go_Airport"
                          ? objectArray2_5
                          : category[0].category === "Go_Rentals"
                          ? objectArray2_5
                          : category[0].category === "Go_Grocery"
                          ? objectArray2_4
                          : objectArray2_3
                      }
                      displayValue="category11"
                      onSelect={selection11}
                    />
                  </div>
                  <div className="col-sm-4 mb-5" id="multiselect">
                    <label>Vehicle Name</label>
                    <Multiselect
                      options={
                        category1[0].category11 == "car"
                          ? objectArray
                          : category1[0].category11 == "Two Wheeler"
                          ? objectArray_3
                          : category1[0].category11 == "auto"
                          ? objectArray_2
                          : category1[0].category11 == "3 Wheeler"
                          ? objectArray_4
                          : objectArray_1
                      }
                      singleSelect
                      displayValue="vehicle"
                      onSelect={selection111}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12"></div>
          <strong>Additions</strong>
          <p>Fare earned by agents for each task.</p>
          <br />
          <div className="form-row align-items-left">
            <div className="col-sm-4">
              <label>Platform Charges</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="0.00"
                  value={transFee}
                  onChange={(e) => setTransFee(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">Rs</div>
                </div>
              </div>
            </div>

            <div className="col-sm-4">
              <label>Distance fare</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="0.00"
                  value={Per_KM}
                  onChange={(e) => setPerKM(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">/km</div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <label>Base fare</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="0.00"
                  value={Base_Fare}
                  onChange={(e) => setBaseFare(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">Rs</div>
                </div>
              </div>
            </div>
          </div>
         
          <div className="form-row align-items-left">
          <div className="col-sm-4">
              <label>Base distance</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="0.00"
                  value={Base_KM}
                  onChange={(e) => setBaseKM(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">km</div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <label> Upto fare(per KM)</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="0.00"
                  value={uptoBaseFare}
                  onChange={(e) => setUptoBaseFare(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">Rs</div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <label> Upto distance</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="0.00"
                  value={uptoBaseKm}
                  onChange={(e) => setUptoBaseKm(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">km</div>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row align-items-left">
            <div className="col-sm-4">
              <label>Go Cash</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="0%"
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">%</div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <label>Rider Commission</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="text"
                  className="form-control"
                  placeholder="Ex 0 to 100"
                  value={riderComm}
                  onChange={(e) => setRiderComm(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">%</div>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <label>Search Distance</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="number"
                  className="form-control"
                  placeholder="in km"
                  value={searchDistance}
                  onChange={(e) => setSearchDistance(e.target.value)}
                />
                <div className="input-group-append">
                  <div className="input-group-text">Km</div>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row align-items-left">
           
            <div className="col-sm-5">
              <label>Vehicle Description</label>
              <div className="input-group mb-2">
                <input
                  onWheel={(e) => e.target.blur()}
                  type="text"
                  className="form-control"
                  placeholder="Enter Vehicle Description"
                  value={vehicleDes}
                  onChange={(e) => setVehicleDes(e.target.value)}
                />
                <button className="btn btn-primary ml-4" onClick={Add}>
                  Add
                </button>
              </div>
            </div>
          </div>
          <small class="text-white mt-3">
            You can add multiple vehicle at a time by clicking Add button
          </small>

          <br />
          <br />
          {vehicle.length !== 0 && (
            <Table responsive id="myTable" className="text-white">
              <thead>
                <tr>
                  <th>
                    <strong className="text-white">Vehicle Name</strong>
                  </th>
                  <th>
                    <strong className="text-white">Base Fare</strong>
                  </th>
                  <th>
                    <strong className="text-white">Base Distance</strong>
                  </th>
                  <th>
                    <strong className="text-white">Upto fare (per KM)</strong>
                  </th>
                  <th>
                    <strong className="text-white">Upto distance</strong>
                  </th>
                  <th>
                    <strong className="text-white">Distance fare</strong>
                  </th>
                  <th>
                    <strong className="text-white">Platform charges</strong>
                  </th>
                  <th>
                    <strong className="text-white">Description</strong>
                  </th>
                  <th>
                    <strong className="text-white">Go Cash</strong>
                  </th>
                  <th>
                    <strong className="text-white">Rider Commission</strong>
                  </th>
                  <th>
                    <strong className="text-white">Search Distance</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* <tr> */}
                {vehicle &&
                  vehicle.map((p, i) => (
                    <tr>
                      <td>{p.Name}</td>
                      <td>{p.Base_KM}</td>
                      <td>{p.Base_Fare}</td>
                      <td>{p.UptoPerKM}</td>
                      <td>{p.UptoBaseKM}</td>
                      <td>{p.Per_KM}</td>
                      <td>{p.VehicleTransactionFee}</td>
                      <td>{p.VehicleDescription}</td>
                      <td>{p.VehicleDiscount}</td>
                      <td>{p.RiderCommission}</td>
                      <td>{p.SearchDistance}</td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
         {vehicle.length!==0&&(
           <div
           // onSubmit={(e) => {
             
           // }}
         >
             
             <hr className="bg-light"></hr>
           <div className="form-row align-items-left mt-4">
           <div className="col-auto">
               <label>City Name</label>
               <div className="input-group mb-2">
                 <input
                   onWheel={(e) => e.target.blur()}
                   type="text"
                   className="form-control"
                   placeholder="enter city name"
                   value={cityName}
                   onChange={(e) => setCityName(e.target.value.toLowerCase())}
                 />
                 <div className="input-group-append">
                   <div className="input-group-text"></div>
                 </div>
               </div>
             </div>
            <div className="mt-1">
            <button className="btn btn-primary ml-4 mt-4" onClick={()=>{
            
             setCityNameArray([...cityNameArray,cityName])
             setCityName('')
             }}>
                 Add 
               </button>
            </div>
           </div>
           <small class="text-white mt-3">
           You can add multiple city name at a time by clicking Add button
         </small>
           {cityNameArray.length!==0&&cityNameArray.map((val,idx)=>{
             return (
               <div className="row mt-2"><div className="col-sm-3">{val}</div> 
             <div className="col-sm-2">
             <Link
               onClick={() => {
                cityNameArray.splice(idx,1)
               }}
               href="#"
               className="btn btn-danger shadow btn-xs sharp"
             >
               <i className="fa fa-trash"></i>
             </Link>
               </div></div>
             )
           })}
           <hr className="bg-light"></hr>
           <div className="form-row align-items-left mt-4">
            
             <div className="col-sm-4">
               <label>Tax</label>
               <div className="input-group mb-2">
                 <input
                   onWheel={(e) => e.target.blur()}
                   type="number"
                   className="form-control"
                   placeholder="Eg: 5%"
                   value={tax}
                   onChange={(e) => setTax(e.target.value)}
                 />
                 <div className="input-group-append">
                   <div className="input-group-text">%</div>
                 </div>
               </div>
             </div>
             <div className="col-sm-4">
               <label>Penalty</label>
               <div className="input-group mb-2">
                 <input
                   onWheel={(e) => e.target.blur()}
                   type="number"
                   className="form-control"
                   placeholder="0.00"
                   value={penalty}
                   onChange={(e) => setPenalty(e.target.value)}
                 />
                 <div className="input-group-append">
                   <div className="input-group-text">Rs</div>
                 </div>
               </div>
             </div>
           </div>

           <div className="form-row align-items-left">
             <div className="col-sm-4">
               <label>
                 Hike <span className="text-danger">*</span>
               </label>
               <div className="input-group mb-2">
                 <input
                   onWheel={(e) => e.target.blur()}
                   type="number"
                   className="form-control"
                   placeholder="Ex. 0.3(equal to 30%)"
                   value={hike}
                   onChange={(e) => setHike(e.target.value)}
                   required
                 />
                 <div className="input-group-append">
                   <div className="input-group-text">12AM to 6AM</div>
                 </div>
               </div>
             </div>
             <div className="col-sm-4">
               <label>
                 Peak Hours(Morning) <span className="text-danger">*</span>
               </label>
               <div className="input-group mb-2">
                 <input
                   onWheel={(e) => e.target.blur()}
                   type="number"
                   className="form-control"
                   placeholder="Ex. 0.3(equal to 30%)"
                   value={peakMorning}
                   onChange={(e) => setPeakMorning(e.target.value)}
                   required
                 />
                 <div className="input-group-append">
                   <div className="input-group-text">8AM to 10AM</div>
                 </div>
               </div>
             </div>
             <div className="col-sm-4">
               <label>
                 Peak Hours(Evening) <span className="text-danger">*</span>
               </label>
               <div className="input-group mb-2">
                 <input
                   onWheel={(e) => e.target.blur()}
                   type="number"
                   className="form-control"
                   placeholder="Ex. 0.3(equal to 30%)"
                   value={peakEvening}
                   onChange={(e) => setPeakEvening(e.target.value)}
                   required
                 />
                 <div className="input-group-append">
                   <div className="input-group-text">5PM to 7PM</div>
                 </div>
               </div>
             </div>
           </div>
          
         <button onClick={(e)=>{submitHandler(e);}} className="btn btn-primary float-right">submit</button>
         </div>
         )}
         
        </div>
      </div>
    </div>
  );
}

export default RiderPricing;
